<template>
    <div class="card-box">
        <span class="num-box">{{ idx }}</span>
        <div class="title-wrap">
            <div class="title" :class="idx ? '' : 'black'">{{ title }}</div>
        </div>
        <div class="content">
            <p v-html="content"></p>
        </div>
        <div class="button-wrap" v-if="$slots.default">
            <slot></slot>
        </div>
        <div class="top"></div>
        <div class="left"></div>
        <div class="right"></div>
        <div class="bottom"></div>
    </div>
</template>
<script>
export default {
    props: {
        idx: {},
        title: {},
        content: {},
    },
};
</script>
<style lang="scss" scoped>
.card-box {
    position: relative;
    background: var(--gray2);
    padding: 80px 20px 40px;
    width: 100%;
    flex: 1 0 370px;
    height: 380px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    min-width: 0;

    .top {
        width: 100%;
        height: 3px;
        position: absolute;
        top: 0;
        left: 0;
        background: var(--orange);
        transition: 0.2s linear;
        transform-origin: left;
        transform: scaleX(0);
    }
    .right {
        width: 3px;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        background: var(--orange);
        transition: 0.2s linear;
        transform-origin: top;
        transform: scaleY(0);
        transition-delay: 0.1s;
    }
    .bottom {
        width: 100%;
        height: 3px;
        position: absolute;
        bottom: 0;
        right: 0;
        background: var(--orange);
        transition: 0.2s linear;
        transform-origin: right;
        transform: scaleX(0);
        transition-delay: 0.2s;
    }
    .left {
        width: 3px;
        height: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        background: var(--orange);
        transition: 0.2s linear;
        transform-origin: bottom;
        transform: scaleY(0);
        transition-delay: 0.3s;
    }

    &:hover {
        box-shadow: 3px 3px 12px rgba(0, 0, 0, 0.1);

        .top {
            transform: scaleX(1);
        }

        .right {
            transform: scaleY(1);
        }

        .bottom {
            transform: scaleX(1);
        }

        .left {
            transform: scaleY(1);
        }
    }

    .num-box {
        position: absolute;
        top: 10px;
        left: 10px;
        width: 40px;
        height: 40px;
        background: var(--orange);
        color: #fff;
        font-size: 22px;
        font-weight: 700;

        display: flex;
        justify-content: center;
        align-items: center;
    }

    .title {
        font-family: 'Pretendard', sans-serif;
        font-weight: 700;
        color: var(--black1);
        font-size: 22px;
        line-height: 1;
        letter-spacing: -0.025em;
        margin-bottom: 30px;
        text-align: center;
        @media screen and (max-width: 768px) {
            font-size: 20px;
        }
    }

    .content p {
        font-family: 'Pretendard', sans-serif;
        text-align: center;
        color: var(--black3);
        font-size: 16px;
        line-height: 1.75;
        letter-spacing: -0.025em;
        font-weight: 400;
        word-break: keep-all;
        @media screen and (max-width: 768px) {
            font-size: 14px;
        }
    }

    .button-wrap {
        margin-top: auto;
    }
}
</style>

<style>
.bold {
    color: var(--black1);
    font-weight: 400;
}

.strike {
    text-decoration: underline;
}
</style>
